var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.9 2.5H6.26669C3.39169 2.5 1.66669 4.21667 1.66669 7.1V13.725C1.66669 16.6167 3.39169 18.3333 6.26669 18.3333H12.8917C15.775 18.3333 17.4917 16.6167 17.4917 13.7333V7.1C17.5 4.21667 15.775 2.5 12.9 2.5Z",
    fill: "#A586FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5167 2.48324C16.025 0.983238 14.5667 0.949904 13.0333 2.48324L12.0917 3.41657C12.0083 3.4999 11.9833 3.61657 12.0167 3.7249C12.6 5.76657 14.2333 7.3999 16.275 7.98324C16.3 7.99157 16.3417 7.99157 16.3667 7.99157C16.45 7.99157 16.5333 7.95824 16.5917 7.8999L17.5167 6.96657C18.275 6.20824 18.65 5.48324 18.65 4.74157C18.65 3.99157 18.275 3.2499 17.5167 2.48324Z",
    fill: "#A586FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8833 8.68255C14.6583 8.57422 14.4417 8.46589 14.2417 8.34089C14.075 8.24089 13.9083 8.13255 13.75 8.01588C13.6167 7.93255 13.4667 7.80755 13.3167 7.68255C13.3 7.67422 13.25 7.63255 13.1833 7.56588C12.925 7.35755 12.65 7.07422 12.3917 6.76588C12.375 6.74922 12.325 6.69922 12.2833 6.62422C12.2 6.53255 12.075 6.37422 11.9667 6.19922C11.875 6.08255 11.7667 5.91589 11.6667 5.74089C11.5417 5.53255 11.4333 5.32422 11.3333 5.10755C11.225 4.87422 11.1417 4.65755 11.0667 4.44922L6.58334 8.93255C6.29167 9.22422 6.00834 9.77422 5.95 10.1826L5.59167 12.6659C5.51667 13.1909 5.65834 13.6826 5.98334 14.0076C6.25834 14.2826 6.63334 14.4242 7.05 14.4242C7.14167 14.4242 7.23334 14.4159 7.325 14.4076L9.8 14.0576C10.2083 13.9992 10.7583 13.7242 11.05 13.4242L15.5333 8.94088C15.325 8.87422 15.1167 8.78255 14.8833 8.68255Z",
    fill: "#A586FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6c08218f3ddbb073d9ea407e8e0cc74b.svg";
export { ForwardRef as ReactComponent };